var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "aria-live": "assertive" } }, [
    _c("div", { staticClass: "flex w-full flex-col  space-y-4 mb-4" }, [
      _c(
        "h3",
        { staticClass: "text-base font-semibold leading-6 text-gray-900 mb-2" },
        [_vm._v(" Preview ")]
      ),
      _c(
        "div",
        {
          staticClass:
            "pointer-events-auto flex w-full max-w-md divide-x divide-gray-200 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
        },
        [
          _c("div", { staticClass: "flex w-0 flex-1 items-center p-4" }, [
            _c("div", { staticClass: "w-full" }, [
              _c("p", { staticClass: "text-sm font-medium text-gray-900" }, [
                _vm._v(" " + _vm._s(_vm.title) + " ")
              ]),
              _c("p", { staticClass: "mt-1 text-sm text-gray-500" }, [
                _vm._v(" " + _vm._s(_vm.description) + " ")
              ])
            ])
          ]),
          !_vm.hideAction
            ? _c("div", { staticClass: "flex" }, [_vm._m(0)])
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex flex-col divide-y divide-gray-200" },
      [
        _c("div", { staticClass: "flex h-0 flex-1" }, [
          _c(
            "button",
            {
              staticClass:
                "flex w-full items-center justify-center rounded-none rounded-tr-lg border border-transparent px-4 py-3 text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:z-10 focus:outline-none focus:ring-2 focus:ring-indigo-500",
              attrs: { type: "button" }
            },
            [_vm._v(" Reply ")]
          )
        ]),
        _c("div", { staticClass: "flex h-0 flex-1" }, [
          _c(
            "button",
            {
              staticClass:
                "flex w-full items-center justify-center rounded-none rounded-br-lg border border-transparent px-4 py-3 text-sm font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500",
              attrs: { type: "button" }
            },
            [_vm._v(" Don't allow ")]
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }